var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancel",
    clipPath: "url(#clip-Cancel)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54261",
    "data-name": "Path 54261",
    d: "M18.276,2.082l-.358-.358a.253.253,0,0,0-.358,0L10,9.284,2.44,1.724a.253.253,0,0,0-.358,0l-.358.358a.253.253,0,0,0,0,.358L9.284,10l-7.56,7.56a.253.253,0,0,0,0,.358l.358.358a.253.253,0,0,0,.358,0L10,10.716l7.56,7.56a.253.253,0,0,0,.358,0l.358-.358a.253.253,0,0,0,0-.358L10.716,10l7.56-7.56A.253.253,0,0,0,18.276,2.082Z",
    fill: "#606060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.cfb577d80f0e69f4990ae84a6c56860e.svg";
export { ForwardRef as ReactComponent };